/* eslint-disable indent */
import { Chip } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../theme';
import { SIZES, VARIANTS } from './constants';

export const Component = styled(Chip)`
  &.MuiChip-root {
    height: 28px;
    color: ${COLORS.black80};
    background: ${COLORS.black06};
    border: 1px solid ${COLORS.black20};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
  }

  &.MuiChip-sizeIcon {
    width: ${({ theme }) => theme.spacing.m4};
    height: ${({ theme }) => theme.spacing.m2};
  }

  &.MuiChip-sizeIconLarge {
    width: ${({ theme }) => theme.spacing.l1};
    height: ${({ theme }) => theme.spacing.l1};
    border-width: 0.5px;
  }

  && .MuiChip-label {
    padding: 0 ${({ theme }) => theme.spacing.s2};
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: 500;
  }

  &&[class*='MuiChip-sizeIcon'] .MuiChip-label {
    display: none;
  }

  && .MuiSvgIcon-root {
    font-size: 16px;
    margin-left: ${({ theme }) => theme.spacing.s2};

    path {
      fill: ${COLORS.black50};
    }
  }

  &&[class*='MuiChip-sizeIcon'] .MuiSvgIcon-root {
    margin: 0;
  }

  &&.MuiChip-sizeIconLarge .MuiSvgIcon-root {
    font-size: 20px;
  }

  && .MuiChip-icon {
    margin-right: -${({ theme }) => theme.spacing.s1};
    margin-left: ${({ theme }) => theme.spacing.s2};
    font-size: 16px;
  }

  && .MuiChip-deleteIcon {
    margin-right: ${({ theme }) => theme.spacing.s2};
    margin-left: 0;
    font-size: 12px;

    path {
      fill: ${COLORS.black60};
    }
  }

  ${({ size, theme }) =>
    size === SIZES.XS &&
    `
      && {
        height: 20px;

        .MuiChip-label {
          padding: 0 7px;
          font-size: ${theme.fontSize.h6};
        }
      }
  `}

  ${({ size }) =>
    size === SIZES.SMALL &&
    `
      && {
        height: 24px;
      }
  `}

  ${({ variant }) =>
    variant === VARIANTS.CONTAINED &&
    `
      && {
        color: ${COLORS.white};
        background: ${COLORS.kinetikBlue};
        border-color: transparent;
      }
  `}

  ${({ variant }) =>
    variant === VARIANTS.ERROR &&
    `
      && {
        color: ${COLORS.red};
        background: ${COLORS.coralLight};
        border-color: ${COLORS.red};

        &&& path {
          fill: ${COLORS.red};
        }
      }
  `}

  ${({ variant }) =>
    variant === VARIANTS.SUCCESS &&
    `
      && {
        color: ${COLORS.green};
        background: ${COLORS.greenLight};
        border-color: ${COLORS.green};

        &&& path {
          fill: ${COLORS.green};
        }
      }
  `}
`;
